import React, { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const Incdec = () => {
    const [Num, setNum] = useState(5);

    const incNum = () => {
        setNum(Num + 1);
    }

    const decNum = () => {
        if (Num > 0) {
            setNum(Num - 1);
        } else {
            alert ('0 is Final');
            setNum(0);
        }
    }
    return (
        <>
            <h1>{Num}</h1>
            <button className="btn btn-primary" onClick={incNum}>Increment <AddIcon /></button>
            <button className="btn btn-danger" onClick={decNum}>Decrement <RemoveIcon /></button>
        
        </>

    )
}

export default Incdec;